import WizardStep from "./WizardStep";

export default class ProcessRevenueStep extends WizardStep {
  type = WizardStep.TYPE_NONE;

  name = 'Failed';
}